import React from 'react'
import { string, object } from 'prop-types'
import AdvertiseTestimonial from '@/component/Primitive/AdvertiseTestimonial'

const AdvertiseTestimonialWidget = ({
  description,
  lightLogoUrl,
  instanceName,
  quote,
  attribution,
  subAttribution,
  images
}) => {
  const getImage = (context, ratio, size) =>
    images?.[`${context}_${ratio}_${size}`]?.[0]

  const largeSrcSet = [
    {
      width: 720,
      src: getImage('desktop_background', '180x163', 720)?.url
    },
    {
      width: 1440,
      src: getImage('desktop_background', '180x163', 1440)?.url
    }
  ]
  const smallSrcSet = [
    {
      width: 320,
      src: getImage('mobile_background', '40x61', 320)?.url
    },
    {
      width: 640,
      src: getImage('mobile_background', '40x61', 640)?.url
    }
  ]

  const brand = {
    name: instanceName,
    logo: getImage('logo', 'free', 720)?.url
  }

  const widgetProps = {
    description,
    image: {
      desktop: {
        srcSet: largeSrcSet,
        alt: 'Advertise Testimonial Image',
        sizes: ['min-width(960px) 50vw', '100vw'],
        src: getImage('desktop_background', '180x163', 1440)?.url
      },
      mobile: {
        srcSet: smallSrcSet,
        alt: 'Advertise Testimonial Image',
        sizes: ['min-width(960px) 50vw', '100vw'],
        src: getImage('mobile_background', '180x163', 640)?.url
      }
    },
    quote: {
      brand,
      text: quote,
      attribution,
      secondaryAttribution: subAttribution
    }
  }

  return <AdvertiseTestimonial {...widgetProps} />
}

AdvertiseTestimonialWidget.propTypes = {
  images: object,
  quote: string,
  attribution: string,
  description: string,
  lightLogoUrl: string,
  instanceName: string,
  subAttribution: string
}

export default AdvertiseTestimonialWidget
